import bodybuilder from 'bodybuilder'
import * as Elasticsearch from '../../../elasticsearch'
import * as Constants from './constants'

export const fetchKnowledgeTiers = (community: string) =>
  Elasticsearch.createEsSearch(Constants.FETCH_KNOWLEDGE_TIERS)(
    community,
    Elasticsearch.Indexes.CommunityPersonActionRollup,
    bodybuilder().size(0)
    .query(
      'match',
      Elasticsearch.DocumentFieldNames.Community,
      community,
    )
    .aggregation(
      'range',
      Elasticsearch.AggFieldNames.UniqueTagCount,
      {ranges: Constants.KNOWLEDGE_TIER_RANGES},
      Elasticsearch.DocumentFieldNames.UniqueTags,
      (a) => a.aggregation(
        'sum',
        Elasticsearch.DocumentFieldNames.TotalOpens,
        Elasticsearch.AggFieldNames.TotalOpenCount,
      ).aggregation(
        'sum',
        Elasticsearch.DocumentFieldNames.TotalClicks,
        Elasticsearch.AggFieldNames.TotalClickCount,
      ).aggregation(
        'sum',
        Elasticsearch.DocumentFieldNames.UniqueOpens,
        Elasticsearch.AggFieldNames.UniqueOpenCount,
      ).aggregation(
        'sum',
        Elasticsearch.DocumentFieldNames.UniqueClicks,
        Elasticsearch.AggFieldNames.UniqueClickCount,
      ).aggregation(
        'sum',
        Elasticsearch.DocumentFieldNames.Deliveries,
        Elasticsearch.AggFieldNames.DeliveryCount,
      ).aggregation(
        'cardinality',
        Elasticsearch.DocumentFieldNames.CommunityPersonId,
        Elasticsearch.AggFieldNames.UniqueCount,
      ),
    )
    .build(),
  )



// WEBPACK FOOTER //
// ./src/pages/reports/knowledge-tiers/actions.ts